import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Modal } from "react-bootstrap";
import CustomerMasterLayout from "../../../../layouts/customer/CustomerMasterLayout";
import "../../../../assets/styles/customer/CustomerMyDiary.css";
import axios from "axios";
import AppContext from "../../../../context/AppContext";
import Swal from "sweetalert2";

/* ══════════════════════════════════
   DISPUTE MODAL
══════════════════════════════════ */
const DisputeModal = ({ entry, onHide }) => {
  const [title, setTitle] = useState("");
  const { baseUrl } = useContext(AppContext);
  const customerId = localStorage.getItem("customerId");

  const submitDispute = () => {
    const formData = new FormData();
    formData.append("subject",         title);
    formData.append("mwcustomer_id", customerId);
    formData.append("raisedby",      "customer");
    formData.append("raisedto",      "distributor");

    axios
      .post(`${baseUrl}/customer/dispute/submitDispute`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        if (response.data.success == true) {
          Swal.fire({
            title: "wow",
            text: response.data.message,
            confirmButtonText: "Okay!",
          });
          onHide();
        }
      })
      .catch((error) => console.log(error));
  };

  return (
    <Modal show={!!entry} onHide={onHide} centered>
      {entry && (
        <div className="cdairy-modal">
          <div className="cdairy-modal__header">
            <div>
              <h6 className="cdairy-modal__title">Generate Dispute</h6>
              <p className="cdairy-modal__sub">Entry: {entry.created_at}</p>
            </div>
            <button className="cdairy-modal__close" onClick={onHide}>
              <i className="bi bi-x" />
            </button>
          </div>
          <div className="cdairy-modal__body">
            <div className="cdairy-form-group">
              <label className="cdairy-form-label">Description</label>
              <textarea
                className="cdairy-input cdairy-input--textarea"
                placeholder="Write Issue"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                rows={4}
              />
            </div>
            <div className="cdairy-modal__actions">
              <button className="cdairy-btn cdairy-btn--outline" onClick={onHide}>
                Cancel
              </button>
              <button className="cdairy-btn cdairy-btn--primary" onClick={submitDispute}>
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
};

/* ══════════════════════════════════
   MAIN
══════════════════════════════════ */
const CustomerMyDairy = () => {
  const [disputeEntry, setDisputeEntry] = useState(null);
  const [milkEnteries, setMilkEnteries] = useState([]);
  const { baseUrl } = useContext(AppContext);
  const customerId = localStorage.getItem("customerId");

  // Stats mock — baad mein API se replace karna
  const ENTRIES_MOCK = milkEnteries.length > 0 ? milkEnteries : [];
  const delivered = ENTRIES_MOCK.filter((e) => e.status === "Delivered").length;
  const missed    = ENTRIES_MOCK.filter((e) => e.status === "Missed").length;

  const stats = [
    {
      icon: "bi-check-circle",
      label: "Received",
      value: delivered,
      sub: "This Month",
      color: "#22c55e",
      bg: "rgba(34,197,94,0.1)",
    },
    {
      icon: "bi-x-circle",
      label: "Missed",
      value: missed,
      sub: "This Month",
      color: "#f59e0b",
      bg: "rgba(245,158,11,0.1)",
    },
    {
      icon: "bi-currency-rupee",
      label: "Payable",
      value: "Rs 1800",
      sub: "This Month",
      color: "#f59e0b",
      bg: "rgba(245,158,11,0.1)",
    },
  ];

  const viewEntries = () => {
    const formData = new FormData();
    formData.append("mwcustomer_id", customerId);

    axios
      .post(`${baseUrl}/customer/milkDiary/viewAllEntries`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        if (response.data.success == true) {
          setMilkEnteries(response.data.milkEnteries);
        }
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    viewEntries();
  }, []);

  return (
    <CustomerMasterLayout>
      <div className="cdairy-wrapper">
        {/* ── Header ── */}
        <div className="cdairy-header">
          <h1 className="cdairy-title">My Dairy</h1>
          <p className="cdairy-subtitle">
            Daily milk entry history from your distributor
          </p>
        </div>

        {/* ── Stat Cards ── */}
        <Row className="g-3 mb-4">
          {stats.map((s, i) => (
            <Col xs={12} sm={4} key={i}>
              <div className="cdairy-stat-card">
                <div className="cdairy-stat-card__top">
                  <div
                    className="cdairy-stat-card__icon"
                    style={{ color: s.color, background: s.bg }}
                  >
                    <i className={`bi ${s.icon}`} />
                  </div>
                  <span className="cdairy-stat-card__sub">{s.sub}</span>
                </div>
                <p className="cdairy-stat-card__val" style={{ color: s.color }}>
                  {s.value}
                </p>
                <p className="cdairy-stat-card__lbl">{s.label}</p>
              </div>
            </Col>
          ))}
        </Row>

        {/* ── Delivery Entries ── */}
        <div className="cdairy-card">
          <div className="cdairy-card__head">
            <h2 className="cdairy-card__title">Delivery Entries</h2>
            <select className="cdairy-month-select">
              <option>February 2026</option>
              <option>January 2026</option>
              <option>December 2025</option>
            </select>
          </div>

          <div className="cdairy-table-wrap">
            <table className="cdairy-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Qty</th>
                  <th>Time</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {milkEnteries.length === 0 ? (
                  <tr>
                    <td colSpan={5} style={{ textAlign: "center", padding: "20px" }}>
                      No entries found
                    </td>
                  </tr>
                ) : (
                  milkEnteries.map((e) => {
                    // ✅ FIX: status undefined hone par crash nahi hoga
                    const status = e.status || "Unknown";

                    return (
                      <tr key={e.id}>
                        <td>{e.created_at}</td>
                        <td>{e.qty}</td>
                        <td className="cdairy-td--time">{e.created_at}</td>
                        <td>
                          <span className={`cdairy-status cdairy-status--${status.toLowerCase()}`}>
                            <span className={`cdairy-status__dot cdairy-status__dot--${status.toLowerCase()}`} />
                            {status}
                          </span>
                        </td>
                        <td>
                          <button
                            className="cdairy-dispute-btn"
                            onClick={() => setDisputeEntry(e)}
                          >
                            Dispute
                          </button>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <DisputeModal entry={disputeEntry} onHide={() => setDisputeEntry(null)} />
    </CustomerMasterLayout>
  );
};

export default CustomerMyDairy;